export interface Founder {
  id: string
  company: string
  founder: string
  sector: string
  image?: string
  imageType?: 'headshot' | 'logo'
  logo?: string
  logoScale?: 'default' | 'large'
}

export const founders: Founder[] = [
  {
    id: '1',
    company: 'Agentflow',
    founder: 'Fatima Abdullahi',
    sector: 'SaaS',
    image:
      'https://cdn.magicpatterns.com/uploads/eF5mDffw2pY1byvpyC1yev/AgentFlow.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/uoKPsMLUSieNpe1E2HWeFZ/agentflow--.png',
  },
  {
    id: '2',
    company: 'CompCrafter',
    founder: 'IG Aigunna',
    sector: 'HR Tech',
    image:
      'https://cdn.magicpatterns.com/uploads/wTyWJKvEUBMcnDAYwaDhaW/CompCrafter.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/vHHQRDXjdqgfGCv2oo4yiG/compcrafter_(1).png',
    logoScale: 'large',
  },
  {
    id: '3',
    company: 'Diaminate',
    founder: 'Sarra Elfadil',
    sector: 'SaaS',
    image:
      'https://cdn.magicpatterns.com/uploads/qbhZpA5WhQqgUuSyZTgJ3K/Sarra.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/t4ZzhCw5JYazEUBPHoat3n/diaminate.png',
    logoScale: 'large',
  },
  {
    id: '4',
    company: 'FundEvolve',
    founder: 'Zainab Williams',
    sector: 'FinTech',
    image:
      'https://cdn.magicpatterns.com/uploads/wtq6vfw1EGE11ZDK1hXn29/Zainab.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/xourrAJvus2wTjXfqAAU6G/fundevolve_(1).png',
  },
  {
    id: '15',
    company: 'GeneLene360',
    founder: 'Phyliss Pobee',
    sector: 'MedTech',
    image:
      'https://cdn.magicpatterns.com/uploads/9aYbPpgZFPtzjmLgE6KRaF/GeneLean360.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/u9J3WGmrKG4hLSGycWWdxY/genelean360.png',
  },
  {
    id: '5',
    company: 'Green Fuel',
    founder: 'Tola Oyin-Alabi',
    sector: 'Clean Tech',
    image:
      'https://cdn.magicpatterns.com/uploads/hrAAfegMYbE354Gxpxrqjp/Tola_Green_Fuel.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/oiCmGoBqPiwQpCBQkSTbRg/greenfuel.png',
  },
  {
    id: '6',
    company: 'Helius Originals',
    founder: 'Bilqees Grant',
    sector: 'Consumer Technology',
    image:
      'https://cdn.magicpatterns.com/uploads/wxDNAvuNy3WA4QLGGjbPf2/Bilqees_Helius_Originals.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/g8U24EmsLzDQQtgYTHotnV/helius.png',
  },
  {
    id: '7',
    company: 'Fem Entity',
    founder: 'Mukisa Kakembo',
    sector: 'HealthTech',
    image:
      'https://cdn.magicpatterns.com/uploads/fmDeYU6gFvTR3PZCmsqbcq/Mukisa.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/auzMKqvRw9msAY9MKikcTz/fementity.png',
  },
  {
    id: '8',
    company: 'KnowMEDIQ',
    founder: 'Margarettha Pierre',
    sector: 'HealthTech',
    image:
      'https://cdn.magicpatterns.com/uploads/vBrjnw6Yb7ovMorqfxTsC9/Margarettha.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/bFBZ5b7z1NTMCsXqoNjbhz/knowmedi---.png',
  },
  {
    id: '9',
    company: 'Kula Foods',
    founder: 'Asha Wheeldon',
    sector: 'Consumer & Food',
    image:
      'https://cdn.magicpatterns.com/uploads/dtH7YKxcyxWfNoBnmfvSKZ/AshaWheeldon.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/o2gQmFFcGwvP4jWfFoP9H9/Kula.png',
  },
  {
    id: '10',
    company: 'Juno',
    founder: 'Nanette Sene',
    sector: 'MedTech',
    image:
      'https://cdn.magicpatterns.com/uploads/ki5m5kJD3twSpbD1TsFksg/Nanette.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/qkw7rn5Mea7vzRX2UgUQJg/juno---.png',
  },
  {
    id: '11',
    company: 'LiiT Care Connect',
    founder: 'Lulu Mashonganyika',
    sector: 'SaaS',
    image:
      'https://cdn.magicpatterns.com/uploads/ev3amjvK62Ry7TqJrTBVae/Lulu_LiitCareConnect.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/2cp9ceRL9jsrSrXfX74XN8/liitcareconnect.png',
  },
  {
    id: '12',
    company: 'OMA Life App',
    founder: 'Chioma Efejedia',
    sector: 'HealthTech',
    image:
      'https://cdn.magicpatterns.com/uploads/gMsu3yqnvFhS3U44Qf9hQt/Chioma.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/n1KU6zopDj5EKRePMHN6Ru/omalife.png',
  },
  {
    id: '13',
    company: 'Seleste Security',
    founder: 'Sylienne Cardichon',
    sector: 'Defence Tech',
    image:
      'https://cdn.magicpatterns.com/uploads/bnAuGfrw2BXDU49qrUn4wT/Sylienne.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/u3LazMKfwR3faKYaCJvg5h/selest.png',
  },
  {
    id: '14',
    company: 'TalentIQ',
    founder: 'Stephanie Martin',
    sector: 'Defence Tech',
    image:
      'https://cdn.magicpatterns.com/uploads/rWQvnukyeVRUJ9Kb1s5oRa/Stephanie_-_TALENT_IQ.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/bCHuuJinKqQh8vSvB3hqch/TalentIQ.png',
  },
]

export const sectors = [
  'All',
  ...Array.from(new Set(founders.map((f) => f.sector))).sort(),
]
